import * as React from "react";
import type { SVGProps } from "react";
const SvgPlayFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m19.52 11.15-13-8a.99.99 0 0 0-1.01-.02C5.19 3.31 5 3.64 5 4v16a1 1 0 0 0 1 1c.18 0 .36-.05.52-.15l13-8c.3-.18.48-.5.48-.85s-.18-.67-.48-.85"
    />
  </svg>
);
export default SvgPlayFilled;
